import { T_Lang } from "@/i18n/types"
import { IPageData, IPageParams } from "../types"
import { IAlarmDetail } from "./alarm.types"

/**
 * $t('enum.E_AiDiagnosisStatus.NotDiagnosis')
 * $t('enum.E_AiDiagnosisStatus.Diagnosising')
 * $t('enum.E_AiDiagnosisStatus.DiagnosisFailed')
 * $t('enum.E_AiDiagnosisStatus.DiagnosisSuccess')
 * 
 * $t('enum.E_AiDiagnosisStatus__2.NotDiagnosis')
 * $t('enum.E_AiDiagnosisStatus__2.Diagnosising')
 * $t('enum.E_AiDiagnosisStatus__2.DiagnosisFailed')
 * $t('enum.E_AiDiagnosisStatus__2.DiagnosisSuccess')
 */
export enum E_AiDiagnosisStatus {
    /**
     * 未诊断
     */
    NotDiagnosis = 0,
    /**
     * 诊断中
     */
    Diagnosising = 1,
    /**
     * 诊断失败
     */
    DiagnosisFailed = 2,
    /**
     * 诊断成功
     */
    DiagnosisSuccess = 3,
}

/**
 * 是否已读
 * $t('enum.E_AiIsRead.NotRead')
 * $t('enum.E_AiIsRead.HasRead')
 */
export enum E_AiIsRead {
    /**
     * 未读
     */
    NotRead = 1,
    /**
     * 已读
     */
    HasRead = 2,
}

export interface IAiAnalystAlarmDiagnosisParams {
    alarmId: number | string
}

export interface IAiDiagnosisConclusion {
    /**
     * 报警id
     */
    alarmId: number
    /**
     * 诊断结论
     */
    conclusion: string
    /**
     * 数据特征
     */
    feature: string
    /**
     * 建议措施
     */
    measure: string
}

export interface IAiAnalystAlarmDiagnosisData extends
    IAiDiagnosisConclusion {
    id
    mappingId
    reasoning
    sensorId
    status
}

export interface IAiAnalystAlarmListParams extends IPageParams {
    aiDiagnosisStatus?: E_AiDiagnosisStatus
    areaId?
    companyId?
    equipmentId?
    mappingId?
    sensorId?
    startTime?
    endTime?
}



export interface IAIAlarmDetail extends IAlarmDetail {
    aiDiagnosisConclusion: IAiDiagnosisConclusion
    aiDiagnosisStatus: E_AiDiagnosisStatus
    isRead: E_AiIsRead
    companyName: string
    areaName: string
    equipmentName: string
    equipmentId: number
}

export type IAiAnalystAlarmListData = IPageData<IAIAlarmDetail>

export interface IAiAnalystAlarmDoDiagnosisParams {
    alarmId: number
    languageType?: T_Lang
}

export type IAiAnalystAlarmDoDiagnosis = IAiDiagnosisConclusion
